import React from 'react'
import PropTypes from 'prop-types'
import Image from '../../Image'

const ViolationDetailCard = ({ violation }) => {
	const formatDate = (dateString) => {
		if (!dateString) return 'N/A'
		try {
			const date = new Date(dateString)
			return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
		} catch (e) {
			return dateString
		}
	}

	return (
		<div style={{
			border: '1px solid #ddd',
			borderRadius: '8px',
			padding: '12px',
			backgroundColor: '#fff',
			boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
			display: 'flex',
			flexDirection: 'column',
			transition: 'box-shadow 0.2s ease',
			cursor: 'pointer'
		}}
		onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)'}
		onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)'}
		>
			{/* Image on top */}
			<div style={{
				width: '100%',
				height: '180px',
				overflow: 'hidden',
				borderRadius: '6px',
				border: '1px solid #e0e0e0',
				marginBottom: '12px'
			}}>
				<Image 
					photo={violation} 
					width='100%' 
					style={{
						width: '100%',
						height: '100%',
						objectFit: 'cover'
					}}
				/>
			</div>
			
			{/* Information below */}
			<div style={{ flex: 1, fontSize: '0.9em' }}>
				<div style={{ marginBottom: '6px' }}>
					<strong style={{ color: '#2c3e50', fontSize: '0.85em' }}>Image ID:</strong>{' '}
					<span style={{ fontSize: '0.9em' }}>{violation.client_image_id || 'N/A'}</span>
				</div>
				
				<div style={{ marginBottom: '6px' }}>
					<strong style={{ color: '#2c3e50', fontSize: '0.85em' }}>Case ID:</strong>{' '}
					<span style={{ fontSize: '0.9em' }}>{violation.case_id || 'N/A'}</span>
				</div>
				
				<div style={{ marginBottom: '6px' }}>
					<strong style={{ color: '#2c3e50', fontSize: '0.85em' }}>Scan date:</strong>{' '}
					<span style={{ fontSize: '0.9em' }}>{formatDate(violation.reg_date)}</span>
				</div>
				
				{violation.comment && (
					<div style={{ marginBottom: '6px' }}>
						<strong style={{ color: '#2c3e50', fontSize: '0.85em' }}>Comment:</strong>
						<div style={{ 
							marginTop: '4px', 
							padding: '6px', 
							backgroundColor: '#f8f9fa',
							borderRadius: '3px',
							fontSize: '0.85em',
							lineHeight: '1.3',
							wordBreak: 'break-word'
						}}>
							{violation.comment}
						</div>
					</div>
				)}
				
				{violation.internal_comment && (
					<div style={{ marginBottom: '6px' }}>
						<strong style={{ color: '#2c3e50', fontSize: '0.85em' }}>Internal:</strong>
						<div style={{ 
							marginTop: '4px', 
							padding: '6px', 
							backgroundColor: '#fff3cd',
							borderRadius: '3px',
							fontSize: '0.85em',
							lineHeight: '1.3',
							wordBreak: 'break-word'
						}}>
							{violation.internal_comment}
						</div>
					</div>
				)}
			</div>
		</div>
	)
}

ViolationDetailCard.propTypes = {
	violation: PropTypes.shape({
		client_image_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		case_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		reg_date: PropTypes.string,
		comment: PropTypes.string,
		internal_comment: PropTypes.string,
		photo_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	}).isRequired,
}

export default ViolationDetailCard
